import { BookOpen } from "lucide-react";
import { useRef } from "react";

import { HowItWorksVideo } from "components/landing/how-it-works/HowItWorksVideo";
import { Section, SectionHeader } from "components/landing/layout/Section";
import { Button } from "components/products/muggleTestV0/components/ui/button";
import { useSectionViewTracking } from "lib/analytics";

/**
 * How it works section featuring a 30-second product walkthrough video.
 */
export function HowItWorksSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useSectionViewTracking("how-it-works", sectionRef);

  return (
    <Section id="how-it-works" className="bg-muted/20 py-10 sm:py-12 lg:py-16">
      <div ref={sectionRef} className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div data-landing-scroll-anchor>
          <SectionHeader
            title="How it works"
            description="Watch our demo video to see how Muggle Test helps you ship with confidence"
            className="mb-6 text-center sm:mb-8"
          />
        </div>

        <div className="mx-auto max-w-4xl">
          <HowItWorksVideo />
        </div>

        <div className="mt-8 text-center sm:mt-10">
          <Button variant="outline" size="lg" className="gap-2" asChild>
            <a href="/muggleTestV0/docs/getting-started/quickstart-by-role">
              <BookOpen className="h-4 w-4" />
              Read the quickstart guide
            </a>
          </Button>
        </div>
      </div>
    </Section>
  );
}
